import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

declare var $:any; 

@Component({
  selector: 'combo-installments',
  templateUrl: './combo-installments.component.html',
  styleUrls: ['./combo-installments.component.scss']
})
export class ComboInstallmentsComponent implements OnInit {

  @Input("label") label              = "Parcelas:";
  @Output("changeValue") changeValue = new EventEmitter();
  @Input("max") max                  = 12;
  @Input("total") total              = 0;
  @Input("method") method:any        = null;
  @ViewChild('select') select:any;
  public data   = [];
  public loader = false;
  @Input("value") value  = 1;
  public response = {
    data: "",
    status: null
  }
  public parcelas:any = [];

  constructor(){
    
  }
  
  /**
   * 
   * 
   * 
   */
  clickValue(parcela:any){
  
    this.changeValue.emit(parcela); 

  }
  /**
   * 
   * Populaas parcelas
   * 
   * 
   */
  populaParcelas(){
    
    this.parcelas = [];
    let installment      = 0;
    let valueInterest    = 0;
    let valueInstallment = 0;
    let y                = 1;
    
    for (var index = 1; index <= this.max; index++) {
          
      installment = this.valueIntallment(index);

      let interestValue   = this.getInterestValue(index);

      if(this.method.interest_active){

        if(interestValue > 0){

          valueInstallment = (this.total)/index;  
          valueInterest    = (valueInstallment+((valueInstallment*interestValue)/100));
          
          this.parcelas.push({
            text: index < 10 ? "0"+index : index,
            value: index,
            interest_active: true,  
            interest_percent: interestValue,
            valueInstallment: installment,
            valueInterest: valueInterest,
            total: (index*valueInterest)
          });

        }else{

          this.parcelas.push({
            text: index < 10 ? "0"+index : index,
            value: index,
            interest_active: false,
            interest_percent: 0,
            valueInstallment: installment
          });

        }

      }else{

        this.parcelas.push({
          text: index < 10 ? "0"+index : index,
          value: index,   
          interest_active: false,
          interest_percent: interestValue,
          valueInstallment: installment
        });

      }
         
    }
    
  }
  /**
   * 
   * Get interest value
   * 
   */
  getInterestValue(installment:any){

    let value = 0;

    for (let index = 0; index < this.method.interest_installment.length; index++) {
      
      if(installment == this.method.interest_installment[index].installment){

        value = parseFloat(this.method.interest_installment[index].value);
        break;

      }
      
    }

    return value;

  }
  /**
   * 
   * Calculate value installment
   * 
   */
  valueIntallment(installment:any){

    return (this.total/installment); 

  }
  /**
   * 
   * Init select
   * 
   * 
   */
  initSelect(){

    let self = this;
    
    $(this.select.nativeElement).val(this.value).select2({
      allowClear: false
    });
    $(this.select.nativeElement).on("select2:select",(e:any) => {

      let value = e.params.data.id;   
      self.value = value;
      self._change();  
  
    });

  }
  /**
   * 
   * Get dataItem
   * 
   */
  _getDataItem(){

    let data = null; 

    for(let index = 0; index < this.data.length; index++) {

      if(this.value == this.data[index]["value"]){  

        data = this.data[index];
        break;

      }
      
    }

    return data;

  }
   /***
   * 
   * Verifica a mudança
   * 
   */
  _change(){

    this.changeValue.emit(this.value);

  }
  /**
   * 
   * Inicializa o dataItem
   * 
   * 
   */
  ngOnInit(){
    this.populaParcelas();
  }
  /***
   * 
   * After
   * 
   */
  ngAfterViewInit(): void {
    this.initSelect();
  }

}
